/**
 * InStoreService Component
 *
 * This component displays a selection of in-store services offered to customers.
 * Each service is represented as a card that includes a title, description,
 * and an image, along with a "BOOK NOW" button for user interaction.
 *
 * Features:
 * - Presents multiple services using a responsive card layout.
 * - Displays images associated with each service to enhance visual appeal.
 * - Provides a button for users to book services directly.
 *
 * Data Structure:
 * - The services are defined in an array of objects, each containing:
 *   - title: A brief title of the service.
 *   - description: A detailed explanation of what the service includes.
 *   - imageUrl: A URL to an image representing the service.
 */

import Button from 'components/commercetools-ui/atoms/button';
import Typography from 'components/commercetools-ui/atoms/typography';
import Link from 'next/link';
import React from 'react';

const InStoreService = () => {
  const cardData = [
    {
      title: 'One hour of expert advice, technique ASSESSMENT, and reviews of your golf gear',
      description:
        'We want to make sure that you are getting the most out of your game, by checking that you have the right equipment to maximise your performance on the golf course and enable you to play your best. We will look at every aspect of your game from club to ball and offer advice on how to use them effectively.',
      imageUrl:
        'https://www.americangolf.co.uk/on/demandware.static/-/Sites/default/dw7cfaee6a/2022/AG/Custom_Fit/Banners/latest/1200x1200.jpg',
      url: 'https://webbooking.americangolf.co.uk/',
    },
    {
      title: '',
      description:
        'We provide a 6 step custom fitting session for FREE. Try out the latest clubs and see for yourself how your game is transformed using our state of the art technology.',
      imageUrl:
        'https://www.americangolf.co.uk/on/demandware.static/-/Sites/default/dw7cfaee6a/2022/AG/Custom_Fit/Banners/latest/1200x1200.jpg',
      url: 'https://webbooking.americangolf.co.uk/',
    },
    {
      title: '',
      description:
        'Ensure your clubs don’t hold you back by restoring your game for 2024. Give your game new strength with a club MOT. Our expert fitters will evaluate your key performance indicators ready for 2024.',
      imageUrl:
        'https://www.americangolf.co.uk/on/demandware.static/-/Sites/default/dw7cfaee6a/2022/AG/Custom_Fit/Banners/latest/1200x1200.jpg',
      url: 'https://webbooking.americangolf.co.uk/',
    },
  ];

  return (
    <section>
      <div className="mb-30 flex justify-center">
        <Typography className="text-center text-[29px] font-bold uppercase leading-[110%] md:text-[36px]">
          Our Instore Services
        </Typography>
      </div>

      <section className="pb-10 lg:pb-20">
        <div className="container mx-auto">
          <div className="flex flex-wrap  justify-between">
            {cardData.map((card, index) => (
              <div key={index} className="flex w-full gap-x-10 p-15 px-4 md:w-1/2 xl:w-[350px]">
                <div className="mb-10 flex h-full flex-col overflow-hidden bg-white duration-300">
                  <img src={card?.imageUrl} alt="image" className="w-full" />
                  <div className="flex flex-grow flex-col justify-between p-8 text-center sm:p-9 md:p-7 xl:p-9">
                    <div className="my-20">
                      {card?.title ? (
                        <h3>
                          <a
                            href="javascript:void(0)"
                            className="text-dark hover:text-primary mb-4 block text-xl font-semibold sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]"
                          >
                            {card?.title}
                          </a>
                        </h3>
                      ) : null}
                      <p className="text-body-color mb-7 text-base leading-relaxed">{card?.description}</p>
                    </div>
                    <Link href={card?.url}>
                      <Button className="mt-22 md:mt-36 md:px-48 md:py-12 lg:mt-32">
                        <Typography as="span" className="text-12 text-black md:text-14 lg:text-16">
                          BOOK NOW
                        </Typography>
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default InStoreService;
